import { Button, styled } from '@mui/material'

import { MessageSent as MessageSentBase } from 'src/components/animations'

export const MessageSent = styled(MessageSentBase)({
  justifySelf: 'center',
  alignSelf: 'center',
})

MessageSent.defaultProps = {
  width: 150,
  height: 150,
}

export const ChangeEmail = styled(Button)(() => ({
  textDecoration: 'underline',
  padding: 0,
  margin: 0,
  display: 'block',

  '&:hover': {
    background: 'transparent',
  },
}))
